import React from "react";
import useResetPasswordForm from "../hooks/useResetPasswordForm"; // Assuming you have/will create this hook

interface ResetPasswordFormProps { }

const ResetPasswordForm = (props: ResetPasswordFormProps) => {
    // Destructuring values from your custom hook
    const {
        formData,
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
        isSubmitting
    } = useResetPasswordForm();

    return (
        <form className="form" onSubmit={handleSubmit} noValidate>
            <h4 className="fw-bolder text-dark mb-6">Security</h4>

            <div className="row mb-6">
                {/* 1. Current (Old) Password Field */}
                <div className="col-lg-12 mb-4">
                    <label className="col-form-label required fw-bold fs-6">Current Password</label>
                    <div className="position-relative mb-3">
                        <input
                            type="password"
                            name="currentPassword"
                            className={`form-control form-control-lg form-control-solid ${touched.currentPassword && errors.currentPassword ? "is-invalid" : ""
                                }`}
                            placeholder="Current password"
                            value={formData.currentPassword}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {touched.currentPassword && errors.currentPassword && (
                            <div className="invalid-feedback">{errors.currentPassword}</div>
                        )}
                    </div>
                </div>

                {/* 2. New Password Field */}
                <div className="col-lg-12 mb-4">
                    <label className="col-form-label required fw-bold fs-6">New Password</label>
                    <input
                        type="password"
                        name="password"
                        className={`form-control form-control-lg form-control-solid ${touched.password && errors.password ? "is-invalid" : ""
                            }`}
                        placeholder="New password"
                        value={formData.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    {touched.password && errors.password && (
                        <div className="invalid-feedback">{errors.password}</div>
                    )}
                    <div className="form-text text-muted">
                        Use 8 or more characters with a mix of letters, numbers & symbols.
                    </div>
                </div>

                {/* 3. Confirm Password Field */}
                <div className="col-lg-12">
                    <label className="col-form-label required fw-bold fs-6">Confirm Password</label>
                    <input
                        type="password"
                        name="confirmPassword"
                        className={`form-control form-control-lg form-control-solid ${touched.confirmPassword && errors.confirmPassword ? "is-invalid" : ""
                            }`}
                        placeholder="Confirm new password"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    {touched.confirmPassword && errors.confirmPassword && (
                        <div className="invalid-feedback">{errors.confirmPassword}</div>
                    )}
                </div>
            </div>

            {/* Actions */}
            <div className="d-flex justify-content-start pt-5">
                <button
                    type="submit"
                    className="btn btn-light btn-active-light-primary text-dark fw-bold border border-secondary"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <span className="indicator-progress" style={{ display: "block" }}>
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    ) : (
                        "Reset Password"
                    )}
                </button>
            </div>
        </form>
    );
}

export default ResetPasswordForm;